import Avatar from '@/assets/images/home/avatar.svg';
import Avatar1 from '@/assets/images/home/avatar_1.svg';
import Avatar2 from '@/assets/images/home/avatar_2.svg';
import Avatar3 from '@/assets/images/home/avatar_3.svg';
import {
  ContentWrapper,
  HomeDescription,
  HomeTitle,
  KeyText,
} from '../../style';
import {
  AvatarImg,
  BasicInfoUser,
  FramePeople,
  Job,
  PeopleItem,
  Quote,
  UserName,
  Wrapper,
} from './style';
import QuoteIcon from '@/assets/images/home/ic_quote.svg';
import { useCallback, useMemo } from 'react';

const People = () => {
  const DATA_PEOPLE = useMemo(
    () => [
      {
        id: 0,
        avatar: Avatar,
        name: 'Danny',
        work: 'Marketing Manager',
        content:
          '"The AI Social Post Generator is a game-changer! It saved me hours of work and boosted our engagement rates. Highly recommended!" ',
      },
      {
        id: 1,
        avatar: Avatar1,
        name: 'Sarah',
        work: 'Content Creator',
        content: `"The AI Writing Assistant elevated my content quality. Correcting grammar and suggesting creative ideas, it's a must-have for creators!"`,
      },
      {
        id: 2,
        avatar: Avatar2,
        name: 'Michael',
        work: 'Entrepreneur',
        content:
          '"The AI Background Changer saved my time and enhanced product visuals. An essential tool for any entrepreneur!"',
      },
      {
        id: 3,
        avatar: Avatar3,
        name: 'Emily',
        work: 'Social Media Manager',
        content:
          '"The AI Photo Enhancer and Social Post Generator are a winning combo for social media management!"',
      },
    ],
    []
  );

  const renderPeoPle = useCallback((people: any) => {
    return (
      <PeopleItem key={people?.id}>
        <AvatarImg src={people.avatar} alt="people-avatar" />

        <Quote src={QuoteIcon} alt="quote-icon" />

        <p>{people.content}</p>

        <BasicInfoUser>
          <UserName>{people.name}</UserName>
          <Job>{people.work}</Job>
        </BasicInfoUser>
      </PeopleItem>
    );
  }, []);

  return (
    <Wrapper>
      <ContentWrapper>
        <KeyText>TESTIMONIALS</KeyText>
        <HomeTitle>{"Don't just take our word for it"}</HomeTitle>
        <HomeDescription>
          From content creators to entrepreneurs, our solutions have
          revolutionized the way they work and create.
        </HomeDescription>
      </ContentWrapper>
      <FramePeople>
        {DATA_PEOPLE.map((people) => renderPeoPle(people))}
      </FramePeople>
    </Wrapper>
  );
};

export default People;
